import { useState, useRef, useEffect } from 'react';

export const useVideoModal = (
  isOpen: boolean,
  videoUrl: string | undefined,
  onVideoEnd?: () => void,
  autoPlay: boolean = true
) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Auto-play video when modal opens
  useEffect(() => {
    if (isOpen && videoUrl && videoRef.current && autoPlay) {
      setIsLoading(true);
      videoRef.current.load();
      videoRef.current.play().catch((error) => {
        console.log('VideoModal autoplay prevented:', error);
      });
      setIsPlaying(true);
    }

    // Cleanup: Stop video when modal closes or videoUrl changes
    return () => {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    };
  }, [isOpen, videoUrl, autoPlay]);

  const handlePlay = () => {
    if (videoRef.current) {
      void videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);
    if (onVideoEnd) {
      onVideoEnd();
    }
  };

  const handleLoadedData = () => {
    setIsLoading(false);
  };

  return {
    videoRef,
    isPlaying,
    isLoading,
    setIsLoading,
    handlePlay,
    handleVideoEnded,
    handleLoadedData,
  };
};
